import type { CalculatorEnv } from "../state";
import { getSlugAndAccesscodeFromUrl } from "./url.ts";
import { environmentFromUrl } from "./environment.ts";

export const getEmployerPortal = (url: string, calculatorEnv: CalculatorEnv): string => {
  if (calculatorEnv === "website" || calculatorEnv === "dealer") {
    return "";
  }
  return getSlugAndAccesscodeFromUrl(url)?.slug ?? "unknown";
};

export const getTrackingDomain = (calculatorEnv: CalculatorEnv): string => {
  if (calculatorEnv === "website") {
    return "website";
  }
  if (calculatorEnv === "dealer") {
    return "dealer";
  }
  if (calculatorEnv === "agpss") {
    return "portal";
  }
  return "";
};

export function environmentFromUrlForTracking(hostname: string, devMode: boolean): "development" | "production" {
  const env = environmentFromUrl(hostname, devMode);
  if (env !== "production") {
    return "development";
  }
  return env;
}
